import * as LocalStorage from 'store/storage/localStorage';

export const apiUrl = `${process.env.REACT_APP_API_URL || `${window.location.origin}/api`
  }`

export const getLoginUrl = () => {
  const loginUrl = LocalStorage.loadLocalState(LocalStorage.BORG_LOGIN_URL)
  if (!loginUrl) {
    return "https://borg.wolterskluwer.pl/"
  }
  return `${loginUrl}`
}

export const getLogoutUrl = () => {
  const session = LocalStorage.loadLocalState(LocalStorage.SESSION)
  const borgLogOnUrl = getLoginUrl()

  if (!session?.technicalData || !borgLogOnUrl) {
    return null
  }

  return `${session.technicalData.borgLogOutUrl}`
}
